/* global axios */
import ApiClient from './ApiClient';

class BlockedDomainsAPI extends ApiClient {
  constructor() {
    super('blocked_domains', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new BlockedDomainsAPI();
